import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("CategoryInputOutput")
export class CategoryInputOutput {
    @JsonProperty()
    public categoryId: string = JsonPropertyEmpty;

    @JsonProperty()
    public slug: string = JsonPropertyEmpty;

    @JsonProperty()
    public label: string = JsonPropertyEmpty;

    @JsonProperty()
    public createdAt?: string = JsonPropertyEmpty;
    @JsonProperty()
    public updatedAt?: string = JsonPropertyEmpty;
    @JsonProperty()
    public count?: number = JsonPropertyEmpty;

    public constructor(args?: Partial<CategoryInputOutput>) {
        Object.assign(this, args);
    }
}
